import { Button, type ButtonProps, useDisclosure, useToast, Image } from "@chakra-ui/react"
import { useAtom } from "jotai"
import { useEffect, useState } from "react"
import { userDetailsAtom } from "../../../components/Menu/menu.store"
import { type ApolloError } from "@apollo/client"
import { ConfirmDialog } from "../confirmDialog"
import { useRemoveFromFmpProjectMutation } from "../../../type-and-hooks"
import { IconDeleteImg } from "../../../components/images"

interface DeleteFMPProps {
  fmpId: number | null | undefined
  projectId: string | undefined
  onDeleteSuccess: VoidFunction
  children?: JSX.Element
  deleteButtonProps?: ButtonProps
}

export const DeleteProjectFromFMP = ({ fmpId, onDeleteSuccess, children, deleteButtonProps, projectId }: DeleteFMPProps): JSX.Element => {
  const [userDetails] = useAtom(userDetailsAtom)
  const [loading, setLoading] = useState(false)
  const [deleteFMPProductMutation, { data: deleteFMPProjectStatus }] = useRemoveFromFmpProjectMutation()
  const toast = useToast()
  const { isOpen, onOpen, onClose } = useDisclosure()

  const handleError = (error: ApolloError | Error): void => {
    setLoading(false)
    toast({
      title: "Error",
      description: error?.message,
      status: "error",
      duration: 5000,
      isClosable: true
    })
  }

  const handleDeleteClick = (): void => {
    if (fmpId === undefined || fmpId === null) {
      return
    }
    onClose()
    setLoading(true)
    if (!projectId || !userDetails?._id || !fmpId) {
      return
    }

    if (userDetails?._id) {
      const userID = userDetails?._id ?? null
      deleteFMPProductMutation({
        variables: {
          input: {
            fmp_project_id: fmpId,
            system_id: [Number(projectId)],
            user_id: userID
          }
        }
      }).catch(handleError)
    } else {
      const missingUserIdError = new Error("Missing userDetails ID. DeleteFMPProject.")
      handleError(missingUserIdError)
    }
    setLoading(false)
  }
  const showToast = (): void => {
    if (deleteFMPProjectStatus) {
      toast({
        title: "Success",
        description: "Deleted Successfully",
        status: "success",
        duration: 5000,
        isClosable: true
      })
      onDeleteSuccess()
    }
  }

  useEffect(showToast, [deleteFMPProjectStatus])

  return (
    <>
      {!children && (
        <Button
          fontSize="12px"
          isLoading={loading}
          whiteSpace="normal"
          variant="linkButton"
          fontWeight="400"
          onClick={onOpen}
          display="flex"
          alignItems="center"
        >
          <Image w="14px" src={IconDeleteImg} alt={"Delete Icon"} />
        </Button>
      )}
      {children && (
        <Button isLoading={loading} onClick={onOpen} {...deleteButtonProps}>
          {children}
        </Button>
      )}

      <ConfirmDialog
        mainActionCallBack={handleDeleteClick}
        isOpen={isOpen}
        onClose={onClose}
        body="Are you sure you want to delete this product service from your FMP ?"
      />
    </>
  )
}
